import type { SubscriptionCancelStore } from './interfaces'

import { useSubscriptionStore } from '../subscription-store/store'

const setCloseGeneralModals = (state: SubscriptionCancelStore): void => {
  state.modalCancelReasons = false
  state.modalTryLearnWay = false
  state.modalKeepLearning = false
  state.modalChangePace = false
  state.modalDiscount = false
  state.modalDiscountSuccess = false
  state.modalCancelWarning = false
  state.modalPremiumTutor = false
  state.modalPauseOffer = false
  state.modalCrossSellDemo = false
  state.modalSuccess = false
  state.modalPauseConfirmed = false
  state.modalImmediate = false

  const subscriptionStore = useSubscriptionStore()
  subscriptionStore.setModalSubscriptionPauseDuration(false)
  subscriptionStore.setModalSubscriptionPauseReason(false)
}

export const actions = {
  setLoading (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['loading']): void {
    this.loading = payload
  },
  setModalCancelReasons (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['modalCancelReasons']): void {
    this.modalCancelReasons = payload
  },
  setModalTryLearnWay (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['modalTryLearnWay']): void {
    this.modalTryLearnWay = payload
  },
  setModalKeepLearning (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['modalKeepLearning']): void {
    this.modalKeepLearning = payload
  },
  setModalChangePace (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['modalChangePace']): void {
    this.modalChangePace = payload
  },
  setCancelReason (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['cancelReason']): void {
    this.cancelReason = payload
  },
  setCancelReasonDescription (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['cancelReasonDescription']): void {
    this.cancelReasonDescription = payload
  },
  setLearnWayReason (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['learnWayReason']): void {
    this.learnWayReason = payload
  },
  setKeepLearningReason (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['keepLearningReason']): void {
    this.keepLearningReason = payload
  },
  setSubscription (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['subscription']): void {
    this.subscription = payload
  },
  setProduct (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['product']): void {
    this.product = payload
  },
  setModalSuccess (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['modalSuccess']): void {
    this.modalSuccess = payload
  },
  setModalPauseConfirmed (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['modalPauseConfirmed']): void {
    this.modalPauseConfirmed = payload
  },
  setModalImmediate (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['modalImmediate']): void {
    this.modalImmediate = payload
  },
  setModalDiscount (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['modalDiscount']): void {
    this.modalDiscount = payload
  },
  setModalDiscountSuccess (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['modalDiscountSuccess']): void {
    this.modalDiscountSuccess = payload
  },
  setModalCancelWarning (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['modalCancelWarning']): void {
    this.modalCancelWarning = payload
  },
  setModalPremiumTutor (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['modalPremiumTutor']): void {
    this.modalPremiumTutor = payload
  },
  setModalPauseOffer (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['modalPauseOffer']): void {
    this.modalPauseOffer = payload
  },
  setModalCrossSellDemo (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['modalCrossSellDemo']): void {
    this.modalCrossSellDemo = payload
  },
  setCloseGeneralModals (this: SubscriptionCancelStore): void {
    setCloseGeneralModals(this)
  },
  setCancelFlow (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['cancelFlow']): void {
    this.cancelFlow = payload
  },
  setCancelDiscount (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['cancelDiscount']): void {
    this.cancelDiscount = payload
  },
  setCrossSellDiscipline (this: SubscriptionCancelStore, payload: SubscriptionCancelStore['crossSellDiscipline']): void {
    this.crossSellDiscipline = payload
  },
  setClear (this: SubscriptionCancelStore): void {
    setCloseGeneralModals(this)
    this.cancelReason = null
    this.cancelReasonDescription = null
    this.learnWayReason = null
    this.keepLearningReason = null
    this.subscription = null
    this.product = null
    this.cancelFlow = false
    this.cancelDiscount = null
    this.crossSellDiscipline = null
  },
}
